// Shared CLEO suggestion timing. Imported by the Cloud Function path and the
// operator inbox (via src/lib/shared), so the HTTP wait, stale verdict, and
// client poll budget stay ordered: HTTP < callable = stale < poll < function
// timeout. Bump CLEO_HTTP_TIMEOUT_MS and the rest move with it, except the
// function timeout, which is set by hand.
//
// Sizing (ENG-6013): Cleo retries Bedrock errors for up to 3 minutes per run
// (LLM_RETRY_BUDGET_S=180) on top of a normal run of up to ~90 s (p99), so a run
// can last ~270 s. The function timeout stays far below Google's 540 s limit for
// Firestore-triggered functions. The cleo-webhook worker has to outlast the same
// run (Lambda, SQS visibility and client timeout of ~420 s).

export const CLEO_HTTP_TIMEOUT_MS = 270_000
export const CLEO_STALE_MARGIN_MS = 10_000
export const CLEO_POLL_MARGIN_MS = 5_000
export const CLEO_BACKGROUND_FUNCTION_TIMEOUT_MS = 300_000

export const CLEO_REQUEST_TIMEOUT = {
  response: CLEO_HTTP_TIMEOUT_MS,
  deadline: CLEO_HTTP_TIMEOUT_MS,
}

export const CLEO_STALE_THRESHOLD_MS =
  CLEO_HTTP_TIMEOUT_MS + CLEO_STALE_MARGIN_MS

export const CLEO_STORED_POLL_BUDGET_MS =
  CLEO_STALE_THRESHOLD_MS + CLEO_POLL_MARGIN_MS

export const CLEO_CALLABLE_TIMEOUT_MS = CLEO_STALE_THRESHOLD_MS

// How often the operator inbox re-reads a stored draft while it generates.
export const CLEO_STORED_POLL_INTERVAL_MS = 4_000
